export default __webpack_public_path__ + "static/media/user-b.924fe52d.svg";